import React, {Component} from "react";
import {Col, Grid, Row} from "react-bootstrap";
import Card from "../../components/Card/Card";
import {DataContentProviders} from "../../components/Middleware/DataContentProviders";
import contentProviders from "../../assets/img/content_providers.png";

class ContentProviders extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };

    }


    render() {
        return (
            <div className="main-content">

                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <Card
                                content={
                                    <Grid fluid>
                                        <Row>
                                            <Col sm={5}>
                                            </Col>
                                            <Col sm={2}>
                                                <div className="center">
                                                    <img className="img-responsive center-block"
                                                         style={{maxHeight: '60px', maxWidth: '100%'}}
                                                         src={contentProviders}
                                                         alt={"contentProviders"}
                                                    />
                                                </div>
                                            </Col>
                                            <Col sm={5}>
                                            </Col>
                                        </Row>
                                    </Grid>
                                }
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12}>
                            <Card
                                content={
                                    <DataContentProviders
                                        listName={"List of Content Providers"}
                                        // handlerFromParent={this.handleChildUpdate}
                                    />

                                }
                            />
                        </Col>
                    </Row>


                </Grid>
            </div>
        )
    }
}

export default ContentProviders;
